<div class="check-compatibility-page" [class.bottom]="!!isAutoCompleteTagVisible">
  <div class="back-section" *ngIf="activeStep === 2" (click)="back()">
    <a><img src="/assets/icon/circle-down-arrow-icon.svg" width="20" height="20" alt="Arrow Icon">Back</a>
  </div>
  <div class="stepper-part">
    <div class="step-circle">
      <circle-progress id="circleBar" class="circle-progress-bar" [percent]="circlePercentage" [radius]="40"
        [titleColor]="'#EF426F'" [outerStrokeWidth]="5" [innerStrokeWidth]="0" [outerStrokeColor]="'#F4436C'"
        [innerStrokeColor]="'#F4436C'" [outerStrokeGradientStopColor]="'#F4436C'" [title]="activeStep + '/2'"
        [animation]="true" [animationDuration]="300" [backgroundColor]="'#FFFCF4'" [backgroundOpacity]="1"
        [backgroundPadding]="-10" [outerStrokeGradient]="true" [startFromZero]="false">
      </circle-progress>
    </div>
    <div class="step-details">
      <p class="step footer">Step <span> {{activeStep}}</span></p>
      <h5>{{stepsDetails[activeStep - 1]?.title}}</h5>
    </div>
  </div>
  <div class="text-part" *ngIf="activeStep === 1">
    <p>FreeUp Mobile rides on America’s largest 5G/4G LTE wireless networks.</p>
    <p>Let’s see where you're covered:</p>
  </div>
  <div class="text-part" *ngIf="activeStep === 2">
    <p>Let’s find out if your Unlocked Device is compatible with the best coverage in your area.</p>
  </div>
  <ng-container *ngIf="activeStep === 1">
    <div class="input-action-part" *ngIf="!showAddressSuccessBanner && !showAddressErrorBanner">
      <form (ngSubmit)="checkAddressCompatibility()" #addressCompatibilityForm="ngForm">
        <div class="form-row">
          <p class="input-title smaller"><b>Enter Full Address:</b></p>
          <p class="caption">Street Number, Address Line, City, State, ZIP Code</p>
          <div class="form-field">
            <label class="outlined-label-input flowed">
              <input [(ngModel)]="address" id="addressRef" type="search" list-formatter="description"
                #addressRef="ngModel" name="addressRef" type="search" (focus)="setFoucs = true"
                (blur)="setFoucs = false;" class="geolocate" placeholder=" " [matAutocomplete]="auto" required
                (input)="changedAddress()" />
              <span>Enter your Address here</span>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addressDetails($event)">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                  {{ option?.description }}
                </mat-option>
              </mat-autocomplete>
            </label>
            <label class="validation-message" *ngIf="!address && addressRef.touched" id="required-address-msg">Address
              is
              a Required Field</label>
            <label class="validation-message" *ngIf="!displayedAddressModel && !!address"
              id="invalid-address-msg">Select an Address from the list</label>
          </div>
        </div>
        <div class="form-actions">
          <button class="button primary" type="submit" id="check-address-button">Check
            Coverage</button>
        </div>
      </form>
    </div>
    <div class="info-banner success-background" *ngIf="!!showAddressSuccessBanner">
      <div class="flex">
        <img src="assets/icon/banner-success-icon.svg" width="32" height="32" alt="Success Icon">
        <div class="banner-content">
          <h5 class="title">Great News!</h5>
          <p class="smaller desc-a">Your address has great coverage:</p>
          <p class="smaller desc-b"><b>{{address}}</b></p>
          <p class="smaller desc-a last">You can go ahead and check your Device’s compatibility next.</p>
          <div class="actions">
            <button class="button primary" id="address-action-btn" (click)="next()">Check Device</button>
            <button class="button tertiary" (click)="retry()">Check Another Address</button>
          </div>
        </div>
      </div>
    </div>
    <div class="info-banner alert-background" *ngIf="!!showAddressErrorBanner">
      <div class="flex">
        <img src="assets/icon/banner-alert-icon.svg" width="32" height="32" alt="Alert Icon">
        <div class="banner-content">
          <h5 class="title">Oops!</h5>
          <p class="smaller desc-a last">{{currentAddressErrorMesssage}}</p>
          <div class="actions">
            <button class="button primary" id="address-action-btn" (click)="retry()">Retry</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="activeStep === 2">
    <div class="input-action-part" *ngIf="!showDeviceResultBanner">
      <form  #equipmentCompatibilityForm="ngForm">
        <div class="form-row">
          <p class="input-title smaller"><b>Enter your Device’s IMEI:</b></p>
          <p class="caption">Dial: *#06# on your phone to get your IMEI</p>
          <div class="form-field">
            <label class="outlined-label-input">
              <input type="tel" required [(ngModel)]="equipment" name="equipmentNumber" id="equipmentNumber"
                data-cy="equipmentNumber" restrictNumbers minlength="11" maxlength="18" #equipmentNumber="ngModel"
                placeholder=" " #imei />
              <span>Enter your IMEI</span>
            </label>
            <label class='validation-message' id="required-equipment-msg"
              *ngIf="(equipmentNumber.errors || invalidIMEI) && !equipment && equipmentNumber.touched">
              Device IMEI is required
            </label>
            <label class='validation-message' *ngIf="equipmentNumber.hasError('minlength')" id="invalid-equipment-msg"
              data-cy="invalid-equipmentNumber-msg">
              Enter a Valid IMEI, it should be between 11-18 digits
            </label>
          </div>
        </div>
        <div class="input-action">
          <a (click)="showWhatIsIMEI()">Where to find Device IMEI?</a>
        </div>
        <div class="form-actions">
          <button class="button primary" type="submit" id="check-phone-button" (click)="checkDeviceCompatibility()">Check your Device</button>
          <button class="button tertiary" type="button" id="skip-link" (click)="skipDevice()" *ngIf="!activationFlow">Skip For
            Now</button>
        </div>
      </form>
    </div>
    <div class="info-banner alert-background" *ngIf="!!showDeviceResultBanner">
      <div class="flex">
        <img src="assets/icon/banner-alert-icon.svg" width="32" height="32" alt="Alert Icon">
        <div class="banner-content">
          <h5 class="title">Oops!</h5>
          <p class="smaller desc-a last">{{!!currentErrorMesssage ? currentErrorMesssage : 'The device you checked is
            not supported on our network at this time. Please try another device.'}}</p>
          <div class="actions">
            <button class="button primary" (click)="retry()">Retry</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>